import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { addEventListener } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

const Tabs = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            callback: PropTypes.func,
        };

        constructor(props) {
            super(props);

            this.state = {
                current: 0,
                isFixed: false,
                tabList: ['头条', '中国足球', '国际足球', 'NBA', '中国篮球', '综合体育'],
            };
        }

        recordTabsTop = 1;

        handleMouseOver = current => {
            this.setState({
                current,
            });
            this.props.callback(current);
        };

        // 兼容 ie7 的 offsetTop 获取方法
        getOffsetTop = dom => {
            let offsetTop = dom.offsetTop;

            if (dom.offsetParent) {
                offsetTop += this.getOffsetTop(dom.offsetParent);
            }

            return offsetTop;
        };

        handleWindowScroll = () => {
            const offsetTop = this.getOffsetTop(document.getElementById('tabs'));

            if (this.recordTabsTop) {
                this.tabsTop = document.getElementById('tabs').offsetTop || offsetTop;
                this.recordTabsTop--;
            }

            // 兼容各主流浏览器
            const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

            if (currentTop > this.tabsTop) {
                this.setState({ isFixed: true });
            } else {
                this.setState({ isFixed: false });
            }
        };

        componentDidMount() {
            this.unBindScrollEvent = addEventListener(window, 'scroll', this.handleWindowScroll);
        }

        componentWillUnmount() {
            // 注销监听函数
            this.unBindScrollEvent();
            this.recordTabsTop = null;
        }

        render() {
            const liList = this.state.tabList.map((item, index) => (
                <li
                    key={index}
                    onMouseOver={() => {
                        this.handleMouseOver(index);
                    }}
                    className={index === this.state.current ? styles.current : null}>
                    {item}
                </li>
            ));

            return (
                <ul className={`${styles.tabsUl} ${this.state.isFixed ? styles.fix : ''}`} id="tabs">
                    {liList}
                </ul>
            );
        }
    },
);

export { Tabs };
export default Tabs;
